// extracted by mini-css-extract-plugin
export default {"preChatImage":"PreChatHeader_preChatImage__NT7tZ"};